import { QuickWidgetsState, QuickWidgetTypes } from "../reducer/user.reducer";

export const WIDGET_LEFT_MARGIN = 60

export const getQuickWidgetConfigs = (toggleWidget: QuickWidgetTypes, quickWidgets: QuickWidgetsState, toggle = false): QuickWidgetsState => {

    const horizontalSortedWidgets = Object.keys(quickWidgets).sort((a, b) => quickWidgets[a as QuickWidgetTypes]!.position!.left - quickWidgets[b as QuickWidgetTypes]!.position!.left) as QuickWidgetTypes[];
    let widgetOrder = Object.keys(quickWidgets).sort((a, b) => quickWidgets[a as QuickWidgetTypes]!.order - quickWidgets[b as QuickWidgetTypes]!.order) as QuickWidgetTypes[];

    if (!widgetOrder.includes(toggleWidget)) {
        widgetOrder.push(toggleWidget)
    } else {
        widgetOrder = widgetOrder.filter(w => w !== toggleWidget).concat(toggleWidget)
    }
    const newConfig: QuickWidgetsState = {}

    widgetOrder.forEach((widgetType, i) => {
        let height = 350;
        let width = 450;
        let title = "";
        let left = WIDGET_LEFT_MARGIN;
        let bottom = 8;

        switch (widgetType) {
            case QuickWidgetTypes.MARKET_DEPTH:
                title = "Market Depth";
                break;
            case QuickWidgetTypes.ORDER:
                width = 600;
                title = "Orders";
                break;
            case QuickWidgetTypes.POSITION:
                width = 600;
                title = "Positions";
                break;
            case QuickWidgetTypes.QUICK_TRADE:
                width = 600;
                title = "Quick Trade";
                break;
            default:
                title = widgetType;
        }

        if (widgetOrder.length > 1) {
            horizontalSortedWidgets.forEach((w) => {
                const widget = quickWidgets[w];

                if (widget!.position!.left < left + width + 8) {
                    left = widget!.position!.left + widget!.dimensions.width + 8
                }
            })

            if (left + width > window.innerWidth) {
                const firstWidget = quickWidgets[horizontalSortedWidgets[0]];
                left = WIDGET_LEFT_MARGIN;
                bottom = firstWidget!.position!.bottom + firstWidget!.dimensions.height + 8
            }
        }

        const existing = quickWidgets[widgetType];
        const isToggled = toggle && toggleWidget === widgetType;

        newConfig[widgetType] = {
            enabled: existing ? (isToggled ? !existing.enabled : existing.enabled) : true,
            visible: true,
            order: i + 1,
            title,
            dimensions: existing ? existing.dimensions : { width , height },
            position: existing?.position ?? { left, bottom },
            settings: existing?.settings ?? {},
        };
    });

    return newConfig
}